import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcDatePicker } from 'components/MprcDatePicker';
import { Formaters } from 'lib/Formaters';
import moment, { Moment } from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAdvFilterCommand, IAdvFilterPickerProps, IAdvFilterResult } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const DateFieldPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const { t } = useTranslation("knowledge");
    const inputRef = useRef<HTMLInputElement | undefined>(undefined);
    const [dateOn, setDateOn] = useState<Moment | null>(null);

    const canApply = !!dateOn && dateOn.isValid();

    ////////////////////////////////////////////////////////////////////////////////

    ///
    function getDisplayText(command: IAdvFilterCommand, DateOn: Date | null): string {
        const textFormatted = `${Formaters.localeDate(dateOn?.toDate())}`;

        return filter.displayPreText != undefined
            ? `${filter.displayPreText}: ${textFormatted}`
            : `${filter?.displayName.replace("...", "")}: ${textFormatted}`;
    }

    ///
    const handleApply = () => {
        const newFilter = {
            command: filter.command,
            text: getDisplayText(filter, dateOn!.toDate()),
            value: dateOn!.startOf("day").toDate()
        } as IAdvFilterResult;

        onApply(newFilter, filter);
    };

    useEffect(() => {
        inputRef.current?.focus();
    }, [inputRef]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <Grid container spacing={4}>
                    <Grid>
                        <MprcDatePicker
                            label={filter.displayName ?? t("Feed.AdvancedFilter.FromLabel")}
                            value={dateOn?.toDate() ?? null}
                            autoFocus
                            onChange={(date) => setDateOn(moment(date))}
                            color="warning"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={!canApply}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
